/**
 * Fetch one XML file and parse it into a DOM.
 * @param {string} url
 * @returns
 */
export async function loadXML(url) {
  const res = await fetch(url, { headers: { Accept: "application/xml" } });
  const text = await res.text();
  return new DOMParser().parseFromString(text, "application/xml");
}
